import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export class AuthHeaderInterceptor implements HttpInterceptor {

  constructor(private accessTokenResolver: () => Promise<string>) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.accessTokenResolver()).pipe(mergeMap(authHeader => {
      if (authHeader) {
        request = request.clone({
          setHeaders: {
            Authorization: authHeader
          }
        });
      }
      return next.handle(request);
    }));
  }
}
